import './QualitativeSamplesTable.css';

import React from 'react';
import B2BTableInMemory from '../../../b2b-common/B2BTableInMemory';
import { Add } from '@mui/icons-material';
import { toLocaleDateTime } from '../../../b2b-common/helpers';
import { renderSampleStatusAndTrend } from '../quant/QuantitativeSamplesTable';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const QualitativeSamplesTable = ({ areaIndicator, onSampleClick, onNewSample = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const headers = [
        { label: t('Sample Date'), align: 'center' },
        { label: t('Value'), align: 'left' },
        { label: t('Status'), align: 'center' },
    ];

    const rows = areaIndicator ? areaIndicator.sampleDTOs
        .sort((a, b) => new Date(a.sampleDate) - new Date(b.sampleDate))
        .map((sample) => ({
            id: sample.sampleId,
            cells: [
                { content: toLocaleDateTime(sample.sampleDate, true), align: 'center' },
                { content: sample.sampleValue.qualitativeValue, align: 'left' },
                { content: renderSampleStatusAndTrend(sample), align: 'center' },
            ],
        })) : [];

    const handleRowClick = (row) => {
        if (onSampleClick) {
            onSampleClick(areaIndicator.sampleDTOs.find(sample => sample.sampleId === row.id));
        }
    };

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            numRows={10}
            className={'qualitative-samples-table'}
            onRowClick={handleRowClick}
            buttons={
                [
                    {
                        label: t('New Sample'),
                        icon: <Add />,
                        onClick: onNewSample,
                    }
                ]
            }
        />
    );
};

export default QualitativeSamplesTable;
